// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dz-uploaded-file[data-v-54bb51c1]{cursor:default}.dz-uploaded-file .dz-filename[data-v-54bb51c1]{width:calc(100% - 155px)}.dz-uploaded-file .dz-size[data-v-54bb51c1]{bottom:10px;left:158px}.dz-uploaded-file .dz-remove[data-v-54bb51c1]{bottom:8px}", ""]);
// Exports
module.exports = exports;
